module.exports = __webpack_public_path__ + "static/img/carousel_5_nx3ajx_ar_4_3_w_1075.0bf1efa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/carousel/carousel_5_nx3ajx_ar_4_3_w_1075.jpg
// module id = r18A
// module chunks = 0